/**
 * Returns the active element.
 * This is just an alias of `document.activeElement`.
 *
 * @return An active element.
 */
export function activeElement(): Element {
  return document.activeElement;
}
